import React, { createContext, useContext } from 'react';
import { useRealtimeSSE } from '../hooks/useRealtimeSSE';

interface RealtimeContextType {
  isConnected: boolean;
  reconnect: () => void;
}

const RealtimeContext = createContext<RealtimeContextType>({
  isConnected: false,
  reconnect: () => {},
});

export const useRealtime = () => useContext(RealtimeContext);

interface RealtimeProviderProps {
  children: React.ReactNode;
}

export const RealtimeProvider: React.FC<RealtimeProviderProps> = ({ children }) => {
  const sse = useRealtimeSSE();

  return (
    <RealtimeContext.Provider value={sse}>
      {children}
    </RealtimeContext.Provider>
  );
};
